import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

import clydeEdnaWedding from '../images/articlePictures/clydeEdnaWedding.png'

const options = {
    thumbnails: {
        showThumbnails: false
    // buttons: {
    //   backgroundColor: "#1b5245",
    //   iconColor: "rgba(126, 172, 139, 0.8)",
    // },
    // caption: {
    //   captionColor: "#a6cfa5",
    //   captionFontFamily: "Raleway, sans-serif",
    //   captionFontWeight: "300",
    //   captionTextTransform: "uppercase",
    }
  };

const ClydeAndEdna = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>Clyde and Edna <br/> From War to Marriage </Header>
                <br/>

            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <br/>
                March 1, 1945 - Brought a letter from Clyde to Edna with a money order to buy an Engagement Ring. On Saturday, March 18, Edna bought an Engagement ring for $220.00.
                <br/>
                <br/>
	            March 20, 1945 - Edna picked up her ring. She won’t put it on until her birthday.
                <br/>
                <br/>
                March 25, 1945 - Edna’s father placed Edna’s ring on her finger and the Engagement became official. He insisted that it should be a man that put the ring on her.
                <br/>
                <br/>
                May 8, 1945 - Edna and two friends from the Y went into Manhattan to watch the lights being turned on at Times Square for the first time since being turned off for the war. She had been feeling down because Clyde had received orders to the USS Cohocton AO-101 with no leave. That meant they couldn’t get married until after the war.
                <br/>
                <br/>
                May 9, 1945 - Edna’s grandmother Caroline Zepf became deathly ill. The family took turns staying up with her all night. On May 11, 1945 at 1:25 AM she passed away. Clyde called Edna long distance.
                <br/>
                <br/>
                June 24, 1945 - Edna returned from a weekend hostel trip to find out that her Cousin Edmund Zepf had been electrocuted on Tinnian. He had touched something in a washing machine and yelled. They immediately cut the power, but he died four hours later. They had been close as children and the upset Edna very much. That night she wrote a short letter to Clyde saying she couldn’t write a letter that night.
                <br/>
                <br/>
                August 6, 1945 - Edna wrote Clyde that she heard on the radio that Major Richard Bong was killed on a test flight. She also mentioned the Atomic bomb and was worried that another country could make one like Russia and bomb New York.
                <br/>
                <br/>
                August 7, 1945 - Edna wrote that news about the Atomic Bomb was on every radio and newspaper.
                <br/>
                <br/>
                August 8, 1945 - Edna wrote that everyone was happy that Russia was coming into the war with Japan. Edna felt that was not a great thing. She felt that now Russia would want to have a great deal of say in the surrender terms.
                <br/>
                <br/>
                August 11, 1945 - Edna arrived at Green Lake for her vacation.
                <br/>
                <br/>
                August 14, 1945 - while writing to Clyde, she heard an announcement that the Japanese Ambassador in Switzerland has just handed over a reply to the American demand for surrender.
                <br/>
                <br/>
                August 15, 1945 -  Edna got the word that the war was over. She was disappointed that she wasn’t in New York. Everything around Green Lake closed including mail delivery.
                <br/>
                <br/>
                September 2, 1845 - Edna went to church. She went because it was VJ-Day.
                <br/>
                <br/>
                September 3, 1945, Labor Day - Harry (Joe Richards) took everyone to the cemetery and then to Alley Pond Park. They got hungry there and the refreshment stand was closed, so they came back to Forest Park. There they had Merry-go-round so Edna took Mickey on it.
                <br/>
                <br/>
                September 5, 1945 - The Cohocton AO-101 departed for the Eniwetok Atoll.
                <br/>
                <br/>
                September 7, 1945 - Edna got a letter from Clyde saying he was now at sea.
                <br/>
                <br/>
                September 21, 1945 - Edna and the immediate family went over to Maizie’s to celebrate their fifth wedding anniversary. The three kids, Mickey, Gary and Judy had a great time with an abundance of energy. At work, Edna was having a feud with Bess Murphy. She was always looking for reasons to pick on Edna.
                <br/>
                <br/>
                September 22, 1945 - Edna went looking for Bridal Gowns. Edna was feeling a little down because she hadn’t a letter from Clyde since September 7. She knew Clyde was at sea, but she missed his letters.
                <br/>
                <br/>
                September 24, 1945 - Edna came home to eleven letters. Clyde told her he was being transferred back to the States for discharge.
                <br/>
                <br/>
                September 28, 1945 - Edna and the family went to Gus and Dot’s to celebrate Bunny’s 3rd birthday.
                <br/>
                <br/>
                October 16, 1945 - Clyde wrote that he was at Midway on the tanker “SS Tampico” He went ashore to look around and thought the place looked great. They had three movie theaters and he went to a movie before going back to the ship. The ship was sailing in the morning.
                <br/>
                <br/>
                October 30, 1945 - Clyde’s Mom (Lucy) wrote to Edna that she received a letter from Clyde saying he was on his way back by tanker, via Balboa and the Panama Canal. Dave Kite said that he was anxious to have Clyde back. He was lining up a contract to deliver freight for Sears and Seaboard Coast Lines.
                <br/>
                <br/>
                November 8, 1945 - Clyde arrived in Galveston, Texas. Edna received a letter on November 13th, telling her he was in Texas.
                <br/>
                <br/>
                November 15, 1945 - Clyde departed Galveston, Texas for Jacksonville.
                <br/>
                <br/>
                November 17, 1945 - Clyde arrived in Jacksonville, Florida, from Galveston, Texas early in the morning. He was sent immediately to the Separation Center for discharge. He was discharged on Monday, the 19th. That night Clyde stayed in a hotel in Jacksonville. He went to a movie his first night out of the Navy. From Jacksonville, Clyde went to Gainesville to meet with his brother-in-law David Kite. David and Clyde decided to run a trucking business together. They would use Dave’s equipment and contracts and Clyde would have to use all the money he had saved in the Navy and buy another truck. Then he traveled down to Fort Myers to see his Mother.
                <br/>
                <br/>
                November 21, 1945 - While in Fort Myers, Clyde wrote to Edna that they could still get married on the 26th of January. He would catch a train and arrive on the 22nd. After the ceremony they would have to come right back. He told her that he would find a nice apartment for them.
                <br/>
                <br/>
                November 22, 1945 -  Clyde with his brother Jay and nephew Benny went fishing at Pine Island. Later, Clyde wrote Edna that Dave and Bert said they could rent one of their houses. It was a small two bedroom house built in 1938.
                <br/>
                <br/>
                November 24, 1945 - Clyde and Jay went hunting. Clyde forgot his jacket and caught a cold.
                <br/>
                <br/>
                November 27, 1945 - Clyde sent a basket of oranges to Edna by train. Clyde also spent time looking for clothes. He need work clothes and a suit for the wedding. Due to war shortages he had little luck.
                <br/>
                <br/>
                December 1, 1945 - Clyde left Fort Myers and went to Tampa to visit Hack and Addie. They went to a movie together, the next day he left Tampa at 4:30 and drove to Gainesville. Dave told Clyde that he would rent him the house for $60.00 per month and it was furnished.
                <br/>
                <br/>
                December 4, 1945 - Clyde and Dave spent the day getting the truck ready for hauling freight.
                <br/>
                <br/>
                December 6, 1945 - Edna wrote that she wanted to get a hotel reservation at the Hotel Pennsylvania for their wedding night. It only cost $6.60 per night. She wanted to stay two nights and leave for Florida on Monday the 28th of January.
                <br/>
                <br/>
                December 8, 1945 - Clyde wrote that now they would have a larger house to live in. This house had two stoves, one gas and one a wood burner. He said that the yard was big, but since she liked to exercise she could mow it. Dave wanted to make sure Clyde had a house to live in, but had problems making sure one was empty.
                <br/>
                <br/>
                December 9, 1945 - Clyde and Dave continued building a truck van on the back of the new truck. Clyde went all around Gainesville looking for a bracelet for Edna for Christmas.
                <br/>
                <br/>
                December 10, 1945 - Clyde spent most of the day painting his truck. Clyde had talked to the freight agent and was told that he would get some jobs hauling freight after the first of the year. So he kept working on getting the truck ready.
                <br/>
                <br/>
                December 11, 1945 - Clyde wrote Edna that they could only stay one night in New York after the Wedding. Dave’s coal and wood business needed his help to get out the winter orders and Dave could not do it alone.
                <br/>
                <br/>
                December 12, 1945 - Edna wrote that she had been busy working and helping her Mom clean. She was thinking of taking a night off and going to Radio City Music Hall and watching “Bell of St Mary.” She had heard it was very good.
                <br/>
                <br/>
                December 17, 1945 - Edna wrote that when she got to Florida, she would sit on the Sun Porch and watch him mow the yard.
                <br/>
                <br/>
                December 24, 1945 - Clyde went to the Atlantic Coast Line train station and inquired about tickets to New York and back. He was told he couldn’t get them until fourteen days before travel.
                <br/>
                <br/>
                December 25, 1945 - Clyde wrote to Edna to thank her for his Christmas gift. He also told her to see if Gus (Edna’s brother) would be his best man.
                <br/>
                <br/>
                December 27, 1945 - Edna received a money order for a $100.00 from Clyde. She told Clyde that she would order the flowers. She also wrote and asked what size the Dining Room table was. People were asking what she wanted for a wedding gift.
                <br/>
                <br/>
                Over the next couple days Clyde was still looking for a suit and Edna was looking for shoes and stockings. The war shortages were still in effect.
                <br/>
                <br/>
                December 30, 1945 - Edna wrote that she and Helen went out to try to rent a hall for the reception. Since all the halls are connected to bars, they got cold feet. They were worried about the men that drank there. They told Gus he had to go make the reservations as best man. Also she wrote Clyde that Alfred (Edna’s brother-in-law) was home from the Pacific for good.
                <br/>
                <br/>
                January 3, 1946 - Edna wrote that they had found a hall and put a deposit on it. It was not quite what they wanted, but it was all they could afford. She still hasn’t found a band. She also said that she was calling hotels and it looks like that they will stay at the St. Georges in Brooklyn. She also asked if soap was available in Florida. There was a shortage of it. She also asked Clyde what his salary was.
                <br/>
                <br/>
                January 6, 1946 - Edna wrote that she had bought a gown and headpiece to go with Jo’s veil. She had gotten an appointed with a photographer and also hired a band for the reception. They had a small family party for Alfred last night.
                <br/>
                <br/>
                January 10, 1946 - Edna wrote that Gus couldn’t be the best man. Her father was too nervous, so Gus had to be the one to give her away. She asked Harry (Joe Richards) to be the best man. She received the announcements. Helen told her she would write them out as she had better handwriting than Edna.
                <br/>
                <br/>
                January 11, 1945 - Edna wrote that the blood test could be done when he arrived there. He even could get it done in Florida as long as it was examined by the State Board of Health. She said that he needed to be in New York by the 22nd. Usually people get their marriage license a week before the ceremony. It was law that you had to get it at least 72 hours before the ceremony.
                <br/>
                <br/>
                January 15, 1946 - Edna wrote to Clyde that his Mom (Lucy) was giving them $100.00 for a wedding present. She said that her parents were also giving them $100.00. She wanted to use that money to buy a Singer Sewing Machine. She said that she could make her own clothes, curtains, etc.
                <br/>
                <br/>
                January 20, 1946 - Edna again wrote that Clyde had to be there on the 22nd.
                <br/>
                <br/>
                Clyde took the Silver Meteor to New York and arrived on the 22nd. They were married on Saturday, January 26, 1946. They spent their wedding night at the Pennsylvania Hotel. The next day they left for Gainesville, Florida.
                <SimpleReactLightbox>
                    <SRLWrapper options={options}>
                    <img src={clydeEdnaWedding} class="articlePhoto" alt="Edna and Clyde Richardson - January 26, 1946" />
                    </SRLWrapper>
                </SimpleReactLightbox>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default ClydeAndEdna